module.exports = __webpack_public_path__ + "static/water-a3eb9a8f1c6ddfe0aa318d3e53cb785d.png";